import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Workload = ({ workload }: SpecProps<"workload">) => {
  const { i18n } = useLingui();

  if (!workload) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.workload",
    message: "Workload",
    comment: "Label for 'Workload'",
  });

  return <FieldValuePair field={field} value={workload} />;
};
